import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SLLayer } from 'src/app/model/sl-layer';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';

export interface SaveLayerParams {
	handler: AnyHandler;
	layer: SLLayer;
}

@Injectable({
	providedIn: 'root'
})
export class SaveLayerDialogService {
	public request$: Subject<SaveLayerParams> = new Subject();
	constructor() { }


	Show(handler: AnyHandler, layer: SLLayer) {
		this.request$.next({
			handler: (handler),
			layer: (layer)
		});
	}
}
